import request from '@request'

/**
 * @description 获取微信二维码
 */
export function generateQrcode() {
  return request({
    url: `/account/weixin/qrcode`,
    method: 'get',
  })
}

/**
 * @description 扫码登录轮询
 */
export function loop(scene_id) {
  return request({
    url: '/account/weixin/task',
    method: 'post',
    params: {
      scene_id,
    },
  })
}

/**
 * @description 微信扫码登录对没有绑定的账号进行绑定
 */
export function bindAccount(data) {
  return request({
    url: `/account/weixin/${data.wid}/bind`,
    method: 'post',
    data: {
      account: data.account,
      password: data.password,
    },
  })
}

export function login({ account, password }) {
  return request({
    url: '/account/sdx/login',
    // url: '/sdx/login',
    method: 'post',
    data: {
      account,
      password,
    },
  })
}

export function getInfo() {
  return request({
    url: '/account/sdx/userinfo',
    // url: '/sdx/userinfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/account/sdx/logout',
    // url: '/sdx/logout',
    method: 'post',
  })
}
export function updatePwd(data) {
  return request({
    url: '/account/sdx/password',
    // url: '/sdx/password',
    method: 'post',
    data,
  })
}

// 短信验证码
export function smsCode(data) {
  return request({
    url: '/account/sms-code',
    method: 'post',
    data,
  })
}

export function picCodeNew() {
  return request({
    url: '/account/image-code',
    method: 'get',
    responseType: 'blob',
    withCredentials: true,
  })
}

// 验证图片验证码
export function confirmPicCode(code) {
  return request({
    url: '/account/verification/' + code,
    method: 'post',
    withCredentials: true,
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/account/sdx/reset-password',
    method: 'post',
    data,
  })
}

/**
 * 获取内容
 */
export function getContent(params) {
  return request({
    url: `/account/content-manage/weight-list`,
    method: 'get',
    params,
  })
}
